<ion-header id="tutorial1" class="ion-no-border">
  <ion-toolbar id="tutorial2" color="tetratech" class="Recovery-trac-header Recovery-trac-header1">
    <div id="tutorial3" *ngIf="!(!isPageOpen && !isSlideOpen)">
      <span id="tutorial4" (click)="back()" class="back"><ion-icon size="medium" class="icon" name="chevron-back-outline"></ion-icon>Back</span>
    </div>
    <span id="tutorial5" class="Title">Tutorial</span>
    <span id="tutorial6" (click)="close()" class="close"><ion-icon size="large" name="close-outline"></ion-icon></span>
  </ion-toolbar>
</ion-header>
<ion-content id="tutorial7" class="team-detail" style="--background: var(--ion-background-color, none)">
  <div id="tutorial8" class="team-detail__content homepage-inner-box">
    <div class="team-detail__list">
      <div id="tutorial9" class="fullPage" *ngIf="!isPageOpen && !isSlideOpen">
        <div id="tutorial0" class="team-detail__card" *ngFor="let tutorial of tutorials">
          <ion-row id="tutorial11" (click)="openPages(tutorial)">
            <ion-col size="11">
              <p id="tutorial12" class="team-detail-options__title">{{ tutorial.title }}</p>
            </ion-col>
            <ion-col>
              <ion-icon id="tutorial13" name="chevron-forward-outline"></ion-icon>
            </ion-col>
          </ion-row>
        </div>
      </div>
      <div class="fullPage" id="tutorial14" *ngIf="isPageOpen && !isSlideOpen">
        <div id="tutorial15" class="team-detail__card" *ngFor="let page of pages">
          <ion-row id="tutorial16" (click)="openSlides(page)">
            <ion-col size="11">
              <p id="tutorial17" class="team-detail-options__title">{{ page.title }}</p>
            </ion-col>
            <ion-col>
              <ion-icon id="tutorial18" name="chevron-forward-outline"></ion-icon>
            </ion-col>
          </ion-row>
        </div>
      </div>
      <div class="fullPage" id="tutorial19">
        <ion-slides id="tutorial20" pager="true" [options]="slideOpts" #theSlides [hidden]="!isSlideOpen">
          <ion-slide id="tutorial21" class="slideHtml" *ngFor="let slide of htmlArray">
            <div id="tutorial22" class="slideHeader">{{ slide.header }}</div>
            <div id="tutorial23" #slideContent class="html" [innerHTML]="slide.body"></div>
            <div class="slideFooter">
              <div class="previous" *ngIf="slide !== first" (click)="previous()">
                <ion-icon name="chevron-back-circle"></ion-icon><p><strong>Previous</strong></p>
              </div>
              <div id="tutorial24" class="next" *ngIf="slide !== last" (click)="next()">
                <p><strong>Next</strong></p><ion-icon name="chevron-forward-circle"></ion-icon>
              </div>
            </div>
          </ion-slide>
        </ion-slides>
      </div>
    </div>
  </div>
</ion-content>
